import React from 'react'

export const ModalLayout = ({ children }) => {
  return (
    <>
      <div className="modal-layout" />
      <div className="modal">
        <div className="modal-centered">
          <div className="modal-content">{children}</div>
        </div>
      </div>
    </>
  );
};
